import React, {
  useEffect
} from "react";
import { useLocation, useNavigate } from "react-router";
import {
  BOOKING
} from "../../config/constants/api";
import { Button, Col, Steps, Row, Card } from "antd";
import { AiFillEnvironment } from "react-icons/ai";
import { useSelector } from "react-redux";
import DashbordSidebar from "../../components/DashboardSidebar";
import { FaArrowLeftLong } from "react-icons/fa6";
import { extractDate, extractTime } from "../../config/helpers";
import { Post } from "../../config/api/post";
import swal from "sweetalert";

const { Step } = Steps;
const RideDetails = ({ status }) => {
  const navigate = useNavigate();
  const token = useSelector((state) => state.user.userToken);
  const location = useLocation();
  const data = location.state?.data;
  useEffect(() => {
    if (!data) {
      navigate(-1);
    }
    // eslint-disable-next-line
  }, []);
  const handleAccept = async () => {
    Post(`${BOOKING.acceptBooking}${data._id}`, {},  token).then((response)=>{
      if(response.status){
        swal("Success", response?.message, "success");
        navigate("/ride", {
          state: { index: "1" },
        });
      }
    }).catch((err)=>{
      console.log(err,'Error')
      const message = err?.response?.data?.message || err?.message;
      if(message){
        swal("Error", message, "error");
      }
    })
  };
  return (
    <div className="shop-page">
      <Row style={{ width: "100%", justifyContent: "center" }}>
        <Col xs={23} md={21}>
          <div className="shop-page-main">
            <Row gutter={[16, 16]}>
              <Col xs={24} md={24} lg={24} xl={24}>
                <div className="my-account-profile">
                  <section className="side-menu-parent">
                    <DashbordSidebar />
                    <div
                      className="about-us-section"
                      style={{ justifyContent: "center" }}
                    >
                      {/* <Badge.Ribbon
                          text={status}
                          color={
                            status === "Paid"
                              ? "green"
                              : status === "Unpaid"
                              ? "red"
                              : "default"
                          }
                        > */}
                      <div className="bg-paren" style={{ width: "100%" }}>
                        <Card
                          className="orderDetails"
                          style={{ padding: "20px 0" }}
                        >
                          <Row
                            style={{
                              width: "100%",
                              justifyContent: "center",
                            }}
                          >
                            <Col lg={24} xs={24}>
                              <div class="arrow-box">
                                <FaArrowLeftLong
                                  className="arrow"
                                  onClick={() => navigate(-1)}
                                />
                              </div>
                            </Col>
                          </Row>

                          <Row gutter={[16, 16]}>
                            <Col
                              lg={24}
                              md={24}
                              xs={24}
                              style={{
                                textAlign: "end",
                                marginBottom: "10px",
                              }}
                            >
                              <Row gutter={[16, 16]} justify={"center"}>
                                <div
                                  id="map"
                                  style={{
                                    // height: "350px",
                                    width: "100%",
                                    zIndex: "1",
                                    position: "relative",
                                  }}
                                >
                                  <Col
                                    lg={24}
                                    md={24}
                                    xs={24}
                                    style={{
                                      textAlign: "end",
                                      zIndex: 999,
                                      position: "relative",
                                    }}
                                  >
                                    <div className="pet-name-pic">
                                      <div>
                                        {/* <h6 className="f-16-black">
                                          Initial Charged Amount: $
                                          {data?.initialCharges}
                                        </h6> */}
                                        <h6 className="f-16-black">
                                          Date: {extractDate(data?.date)}
                                        </h6>
                                        <h6 className="f-16-black">
                                          Time: {extractTime(data?.time)}
                                        </h6>

                                        {/* <p className="web-p">
                                            Time: {formatTime(ride?.time)}
                                          </p> */}
                                        {/* <p className="web-p">
                                            Time: 12:00:00 pm
                                          </p> */}
                                      </div>
                                    </div>
                                    {/* {ride?.status === "PENDING" && (
                                          <Button
                                            className="web-btn"
                                            onClick={handleBidModal}
                                          >
                                            Apply For Bid
                                          </Button>
                                        )} */}
                                  </Col>
                                  <Col
                                    lg={24}
                                    md={24}
                                    xs={24}
                                    style={{
                                      textAlign: "center",
                                      zIndex: 999,
                                      position: "relative",
                                    }}
                                  >
                                    {/* <Image
                                      src={UPLOADS_URL + data?.user?.image}
                                      alt=""
                                      className="img-fluid"
                                      style={{
                                        maxWidth: "220px",
                                        maxHeight: "220px",
                                      }}
                                      preview={false}
                                    /> */}
                                    <h5>
                                      {data?.user?.firstName +
                                        " " +
                                        data?.user?.lastName}
                                    </h5>
                                    {/* <h5>John Doe</h5> */}
                                  </Col>
                                </div>

                                <Col lg={18} md={20} xs={24}>
                                  <Steps
                                    direction="vertical"
                                    size="small"
                                    current={0}
                                    className="mb-1"
                                    style={{
                                      // padding: "18px 0",
                                      padding:"40px",
                                      backgroundColor: "#e7e7e7",
                                      borderRadius: "20px",
                                      marginBottom: "20px",
                                    }}
                                  >
                                    <Step
                                      title="Pickup Location"
                                      icon={
                                        <AiFillEnvironment
                                          style={{ color: "#bd8230" }}
                                        />
                                      }
                                      // description="Abc road, 123 Street New York"
                                      description={
                                        data?.pickupLocation?.address
                                      }
                                    />
                                    <Step
                                      title="Destination"
                                      icon={<AiFillEnvironment />}
                                      // description="4264 Nelm Street, 123 Street Chicago"
                                      description={
                                        data?.dropoffLocation?.address
                                          ? data?.dropoffLocation?.address
                                          : "Unknown"
                                      }
                                    />
                                  </Steps>
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      gap: "10px",
                                    }}
                                  >
                                    <>
                                      <Button
                                        className="web-btn"
                                        onClick={handleAccept}
                                      >
                                        Accept
                                      </Button>
                                      <Button
                                        className="web-btn2"
                                        onClick={() => {
                                          navigate("/ride", {
                                            state: { index: "2" },
                                          });
                                        }}
                                      >
                                        Ignore
                                      </Button>
                                    </>
                                  </div>
                                </Col>
                              </Row>
                              <Row>
                                {data?.notes && (
                                  <Col xs={22} md={24} lg={20} xxl={12}>
                                    <div className="">
                                      <h5 className="font-euclid text-lg max-xl:text-sm text-black font-bold mb-1 ">
                                        Additional Notes
                                      </h5>
                                      <p className="font-euclid text-sm max-sm:text-xs text-gray-500 font-normal mb-6">
                                        {/* Lorem ipsum dolor sit amet, consectetur
                                        adipiscing elit. Aenean euismod bibendum
                                        laoreet. Proin gravida dolor sit amet
                                        lacus accumsan et viverra justo commodo.
                                        Proin sodales pulvinar tempor. Cum
                                        sociis natoque penatibus et magnis dis
                                        parturient montes, nascetur ridiculus
                                        mus. Nam fermentum, nulla luctus
                                        pharetra vulputate, felis tellus mollis
                                        orci, sed rhoncus sapien nunc eget odio.
                                        Lorem ipsum dolor sit amet, consectetur */}
                                        {data?.notes}
                                      </p>
                                    </div>
                                  </Col>
                                )}
                              </Row>
                            </Col>
                          </Row>
                        </Card>
                      </div>
                      {/* </Badge.Ribbon> */}
                    </div>
                  </section>
                </div>
              </Col>
            </Row>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default RideDetails;
